import type { PropsWithChildren } from 'react'
import React from 'react'
import { useIntl } from 'react-intl'
import PromotionLabel from 'LuxKit/Label/PromotionLabel'
import { formatInclusionsTitleBonus } from 'constants/inclusions'
import CSSBreakpoint from 'components/utils/CSSBreakpoint'
import LabeledSheet from 'LuxKit/LabeledSheet'
import styled from 'styled-components'
import { rem } from 'polished'

const ContentWrapper = styled.div`
  padding: ${rem(16)};
`

interface Props {
  duration?: number
}

function BonusInclusionsLabeledContainer(props: PropsWithChildren<Props>) {
  const { duration, children } = props
  const intl = useIntl()

  const durationLabel = duration
    ? intl.formatMessage(
        {
          id: 'IDGwubTvMEj6K7DVSM28',
          defaultMessage: '{title} for {duration, plural, one {a # night stay} other {# night stays}}',
          description: 'Promotion label for bonus inclusions with minimum stay duration',
        },
        { title: formatInclusionsTitleBonus(intl), duration },
      )
    : formatInclusionsTitleBonus(intl)

  return <LabeledSheet
    kind="highlight"
    data-testid="bonus-inclusions-labeled-container"
    label={<>
      <CSSBreakpoint not="tablet">
        <PromotionLabel variant="premium" format="propercase">{durationLabel}</PromotionLabel>
      </CSSBreakpoint>
      <CSSBreakpoint only="tablet">
        <PromotionLabel variant="premium" format="propercase">{formatInclusionsTitleBonus(intl)}</PromotionLabel>
      </CSSBreakpoint>
    </>}
  >
    <ContentWrapper>
      {children}
    </ContentWrapper>
  </LabeledSheet>
}

export default BonusInclusionsLabeledContainer
